import React from 'react';
import { Icon, IconProps } from '@amzn/awsui-components-console';

const ExpandIcon = ({ variant }: IconProps) => {
  return <Icon name="caret-right-filled" variant={variant || 'link'} />;
};

export default ExpandIcon;
